// 导入封装好的 axios 实例
import request from '@/utils/request'

export function checkOfficeAndEquipmentRef(data) {
    return request({
        url: '/program/equipment/sync/checkRef',
        method: 'post',
        data
    })
}


export function firstSync(data) {
    return request({
        url: '/program/equipment/sync/firstSync',
        method: 'post',
        data
    })
}

export function syncPage( data){
    return request({
        url: '/program/equipment/sync/page',
        method: 'post',
        data
    })
}

export function putSyncUpdate(data) {
    return request({
        url: '/program/equipment/sync',
        method: 'put',
        data
    })
}

// 上报
export function pushReport(id) {
    return request({
        url: `/program/equipment/sync/report/${id}`,
        method: 'get',
    })
}

export function singlePush(id) {
    return request({
        url: `/program/equipment/sync/singlePush?id=${id}`,
        method: 'get',
    })
}

// 开启自动上报
export function pushAutoReport(id) {
    return request({
        url: `/program/equipment/sync/autoReport?syncId=${id}`,
        method: 'get',
    })
}


export function cancelSync(id) {
    return request({
        url: `/program/equipment/sync/cancel/${id}`,
        method: 'delete',
    })
}

export function refreshStbTemplate(data){
    return request({
        url: '/program/equipment/sync/stbTemplate',
        method: 'post',
         data
    })
}

export function wasteList(data){
    return request({
        url: '/program/stb/waste/type/page',
        method: 'post',
         data
    })
}

export function facilityList (data){
    return request({
        url: '/program/stb/facility/type/page',
        method: 'post',
        data
    })
}

// 保存同步参数
export function saveSyncParam(data) {
    return request({
        url: '/program/equipment/sync/setting',
        method: 'post',
        data
    })
}

export function updateSyncParam(data) {
    return request({
        url: '/program/equipment/sync/setting',
        method: 'put',
        data
    })
}

export function getSyncParam(id) {
    return request({
        url: `/program/equipment/sync/setting/getByEquipmentId/${id}`,
        method: 'get',
    })
}

// 获取台账记录
export function oliRecord(data) {
    return request({
        url: '/program/waste/produce/record/page',
        method: 'post',
        data
    })
}

// 上报台账
export function customReport(data) {
    return request({
        url: `/program/waste/produce/record/custom`,
        method: 'post',
        data
    })
}

// 删除台账
export function deleteRecord(id) {
    return request({
        url: `/program/waste/produce/record/remove/${id}`,
        method: 'delete',
    })
}

// 导出台账
export function exportOli() {
    return request({
        url: '/program/equipment/sync/export',
        method: 'get',
        responseType: 'blob'
    })
}

// 查询设备列表
export function findEquipmentList() {
    return request({
        url: '/program/equipment/sync/queryUpstreamDevice',
        method: 'get',
    })
}

// 设置设备sid
export function setEquipmentSid(data) {
    return request({
        url: '/program/equipment/sync/setDeviceSid',
        method: 'put',
        data
    })
}

// 查询读数
export function queryReading(id) {
    return request({
        url: `/program/equipment/sync/querySensorValue/${id}`,
        method: 'get',
    })
}

export function findDistanceSensor(id) {
    return request({
        url: `/program/equipment/sync/findDistanceSensor/${id}`,
        method: 'get',
    })
}

